<template>
    <transition :name="transition">
    <div class="gradient-box" v-if="visible">
        <slot/>
    </div>
    </transition>
</template>

<script>
export default {
    name: 'GradientBox',
    props: [ 'transition' ],
    data: function () {
        return {
            visible: false
        }
    },
    methods: {
        setVisible: function () {
            this.visible = true
        }
    },
    mounted: function () {
        this.setVisible()
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@keyframes gradient {
    0% {background-position: 0% 50%;}
    50% {background-position: 100% 50%;}
    100% {background-position: 0% 50%;}
}
.gradient-box {
    @include gradient-45;
    background-size: 800%;
    animation: gradient 18s infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/common/GradientBox.vue